export default __webpack_public_path__ + "static/media/corner-apple.dab8fb01.webp";